import React from "react"
import Modal from "@components/modal"
import BlockHero from "@components/common/blockHero"
import ModalHitosContent from "@components/common/modalHitosContent"
import Youtube from "@components/youtube"
import ChangeModalBtn from "@components/common/changePageBtn"
import BlockIcons from "@components/common/blockIcons"

const Rsc = () => {
  return (
    <Modal title="MUGARRIAK ETA ESTRATEGIA">
      <div className="mainModal-container">
        <div className="element">
          <BlockHero>
            <div className="title">RSC 4,0:</div>
            <div className="subtitle">
              Lanean dihardugu gure helburua lortzeko.
            </div>
            <div className="description">
              2020an, "RSC 4.0: lanean dihardugu gure helburua lortzeko”
              deritzon 2018-2020 aldirako RSC Plan zuzentzailearen garapena ere
              amaitu zen. Plana erakundeak ekonomiarekin, osasunarekin eta
              ongizatearekin edo klima-aldaketarekin lotutako erronka berrien
              aurrean duen erantzuna da.
            </div>
          </BlockHero>
        </div>
        <div className="element rsc">
          <ModalHitosContent>
            <div className="content">
              <div className="title">
                2018-2020 aldirako RSC Plan zuzentzailearen jarduteko
                printzipioak
              </div>
              <div className="description">
                Planak hiru lan ildo garatu ditu, langileentzat,
                mutualistentzat, Erakundearentzat berarentzat eta gizarte
                osoarentzat erantzukizun-balioa duten 12 ekimenetan banatuta.
                Eguneratzeko zeharkako estrategia gisa, eremu horien baitan
                garatutako ekintzak memoria honetan dagozkien ataletan daude
                jasota. Gainera, aipatzekoa da Mutua Universalek egoera
                ahulenean dauden taldeei laguntzeko etengabe egiten duen lana.
              </div>
              <Youtube link="https://youtube.com/embed/I1RLCLs8gso"></Youtube>
            </div>
            <div className="content">
              <div className="title">
                Interes taldeekiko komunikazioa eta elkarrizketa
              </div>
              <div className="description">
                Bere jarduteko printzipioak garatzeko orduan, Mutua Universalek
                kontuan hartzen ditu bere interes taldeen itxaropenak eta
                beharrak, eta horietako bakoitzarekin harremanetan jartzeko
                berariazko bideak garatzen ditu. 2021eko ekitaldiko lehen
                hiruhilekoan Mutua Universalen interes taldeak berrikusi eta
                eguneratu dira, eta taula honetan zehazten den moduan finkatu
                dira:
              </div>
              <div className="image eusicons">
                <div className="title">gure talde interesdunak</div>
                <BlockIcons
                  text={[
                    "LANGILE BABESTUAK",
                    "ENPLEGATUAK",
                    "HORNITZAILEAK",
                    "BAZKIDETUTAKO ENPRESAK ETA AUTONOMOAK",
                    "GOBERNU ORGANOAK ETA PARTE HARTZEA",
                    "HERRI ADMINISTRAZIOA ETA GIZARTE ERAGILEAK",
                    "AHOLKULARITZAK",
                    "GIZARTE SEGURANTZAREKIN LANKIDETZAN DIHARDUTEN MUTUALITATEEN SEKTOREA",
                    "GIZARTEA",
                  ]}
                ></BlockIcons>
              </div>
            </div>
            <div className="bottomText">
              <div className="description">
              Gizarte Erantzukizun Korporatiboaren Planak indartu egiten ditu Mutua Universalen konpromisoa eta autoexijentzia, Gizarte Segurantzarekin elkarlanean diharduen mutualitate gisa erantzukizun handiagoz jokatzeko, aurrera eramaten dituen jarduera guztietan.
              </div>
            </div>
          </ModalHitosContent>
        </div>
        <div className="changeBtn">
          <ChangeModalBtn />
        </div>
      </div>
    </Modal>
  )
}

export default Rsc
